import { useState } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import './styles.css'
import { parseISODate, toISODate } from './utils'

/**
 * Date input — react-datepicker themed to the suite's gold/cream design, with
 * month and year dropdowns for jumping decades without scrolling months.
 *
 * Drop-in for `<input type="date">`: `value` is a 'YYYY-MM-DD' string and
 * `onChange` receives `{ target: { name, id, value } }`, so existing form
 * handlers keep working untouched.
 */
export default function DateField({
  id,
  name,
  value,
  onChange,
  min,
  max,
  required = false,
  disabled = false,
  placeholder = 'dd/mm/yyyy',
  className = 'field',
}) {
  /* Uncontrolled fallback, so this drops into places where the native input
     carried no value/onChange either. */
  const [inner, setInner] = useState('')
  const controlled = value !== undefined
  const current = controlled ? value : inner

  const emit = (d) => {
    const next = toISODate(d)
    if (!controlled) setInner(next)
    onChange?.({ target: { name, id, value: next } })
  }

  return (
    <DatePicker
      id={id}
      name={name}
      selected={parseISODate(current)}
      onChange={emit}
      minDate={parseISODate(min) || undefined}
      maxDate={parseISODate(max) || undefined}
      dateFormat="dd/MM/yyyy"
      placeholderText={placeholder}
      className={className}
      wrapperClassName="df-wrap"
      popperClassName="df-pop"
      calendarClassName="df-cal"
      /* Popper renders in a body-level portal so overflow-hidden/scroll
         containers (modals, cards) can never clip the calendar. */
      portalId="astro-datefield-portal"
      showMonthDropdown
      showYearDropdown
      scrollableYearDropdown
      yearDropdownItemNumber={120}
      showPopperArrow={false}
      required={required}
      disabled={disabled}
      autoComplete="off"
    />
  )
}
